import { joinURL, parseURL } from 'ufo'

/** media.gokonfetti.com/{id}/{segment}/{filename} — segment may be -, Nx0, NxM */
const KONFETTI_MEDIA_PATH = /^\/(\d+)\/([^/]+)\/(.+)$/i

export interface KonfettiGalleryImageSource {
  id?: number
  filename?: string
  cropped?: string
  original?: string
  thumb?: string
}

export const replaceSubdomainToProd = (url: string) =>
  url
    ? url.replace(
        'https://media.hml.gokonfetti.com/',
        'https://media.gokonfetti.com/'
      )
    : url

export const buildKonfettiMediaUrl = (
  mediaId: number | string,
  filename: string,
  width: number,
  host = 'https://media.gokonfetti.com'
): string => {
  const base = host.replace(/\/$/, '')
  return `${base}/${mediaId}/${width}x0/${filename}`
}

export const toKonfettiWidth = (
  src: string,
  width: number,
  baseURL = 'https://media.gokonfetti.com'
): string => {
  if (!src) {
    return src
  }

  const segment = `${width}x0`
  const base = baseURL.replace(/\/$/, '')

  if (src.startsWith('http://') || src.startsWith('https://')) {
    const u = parseURL(src)
    const pathname = u.pathname || ''
    const m = pathname.match(KONFETTI_MEDIA_PATH)
    if (!m) {
      return src
    }
    const [, id, , filename] = m
    const host = u.host ? `${u.protocol}//${u.host}` : base
    return joinURL(host, `/${id}/${segment}/${filename}`)
  }

  const pathname = src.startsWith('/') ? src : `/${src}`
  const m = pathname.match(KONFETTI_MEDIA_PATH)
  if (!m) {
    return joinURL(base, pathname)
  }
  const [, id, , filename] = m
  return joinURL(base, `/${id}/${segment}/${filename}`)
}

export const toKonfettiWidthForGalleryItem = (
  item: KonfettiGalleryImageSource,
  width: number
): string => {
  const baseUrl = replaceSubdomainToProd(
    item.cropped || item.thumb || item.original || ''
  )

  if (baseUrl) {
    const pathname = baseUrl.startsWith('http')
      ? parseURL(baseUrl).pathname || ''
      : baseUrl.startsWith('/')
        ? baseUrl
        : `/${baseUrl}`

    if (KONFETTI_MEDIA_PATH.test(pathname)) {
      return toKonfettiWidth(baseUrl, width)
    }

    if (!item.id || !item.filename) {
      return baseUrl
    }
  }

  if (item.id && item.filename) {
    return buildKonfettiMediaUrl(item.id, item.filename, width)
  }

  return baseUrl
}
